import ApiService from '../services/ApiService';

export default class UserRepository {
    constructor() {
        this.apiService = new ApiService();
    }

    convertSortString(sortString) {
        switch (sortString) {
            case 'roleName':
                return 'role';
            case '-roleName':
                return '-role';
            case 'referralId':
                return 'referral_id';
            case '-referralId':
                return '-referral_id';
            case 'isCelebrity':
                return 'is_celebrity';
            case '-isCelebrity':
                return '-is_celebrity';
            default:
                return sortString;
        }
    }

    createUser(name, email, password, passwordConfirmation, role) {
        return new Promise((resolve, reject) => {
            this.apiService
                .post('users', {
                    name: name,
                    email: email,
                    password: password,
                    confirm_password: passwordConfirmation,
                    role_id: role
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    deleteUser(id) {
        return new Promise((resolve, reject) => {
            this.apiService
                .delete('users/' + id)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    getUsers(sort = '') {
        return new Promise((resolve, reject) => {
            this.apiService
                .get('users?sort=' + this.convertSortString(sort))
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    getUsersFilteredByNameAndRole(name, roleId) {
        return new Promise((resolve, reject) => {
            this.apiService
                .get(`users?filter[name]=${name}&filter[role_id]=${roleId}`)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    updateUser(id, name, email, password, passwordConfirm, role) {
        return new Promise((resolve, reject) => {
            let data = {
                name: name,
                email: email,
                role_id: role
            };

            if (password !== '') {
                data.password = password;
                data.confirm_password = passwordConfirm;
            }

            this.apiService
                .put('users/' + id, data)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    updateUserIsCelebrity(id, name, email, isCelebrity) {
        return new Promise((resolve, reject) => {
            let data = {
                name: name,
                email: email,
                is_celebrity: isCelebrity
            };

            this.apiService
                .put('users/' + id, data)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    updateUserReferralId(id, name, email, referralId) {
        return new Promise((resolve, reject) => {
            let data = {
                name: name,
                email: email,
                referral_id: referralId
            };

            this.apiService
                .put('users/' + id, data)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}
